module.exports = __webpack_public_path__ + "static/menu-Music-331099139d7b2e81e87f77327e08c90d.png";